import { gql } from '@apollo/client';

export const TRANSFER_ALL_LINE_ITEMS = gql`
    mutation TransferAllLineItems($sourceCartId: String!, $targetCartId: String!) {
        transferAllLineItems(sourceCartId: $sourceCartId, targetCartId: $targetCartId)
    }
`;
